// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3nJK4","content":"LayoutSettings_content__3y7ej"};